import * as utils from "common/utils";
import { HelpTooltip } from "components/Help";

export default function ProjectedResultsWidget({ title, platformResults }) {
    if (!platformResults)
        return null;

    let platform = "platform";
    if (title) {
        platform = title.toLowerCase();
    }

    return (
        <>
            <div className="u-flex u-flexWrap u-flexJustifyCenter u-mt-md">
                <div className="ColourPanel ColourPanel--nloss">
                    <div className="u-pl-md">
                        <h5>
                            Nitrogen loss
                            <HelpTooltip tip={`The estimated nitrogen loss from the ${platform}`} />
                        </h5>
                        <div className="u-mt-sm u-pl-lg">
                            <div className="HeroValue-item-number" id="nloss-total">
                                {utils.numeric.format(platformResults.nitrogen.totalLoss.value)} <small>{platformResults.nitrogen.totalLoss.unit.notation}</small>
                            </div>
                            <div className="HeroValue-item-number" id="nloss-ha">
                                {utils.numeric.format(platformResults.nitrogen.lossPerHectare.value, 1)} <small>{platformResults.nitrogen.lossPerHectare.unit.notation}</small>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="ColourPanel ColourPanel--ploss">
                    <div className="u-pl-md">
                        <h5>
                            Phosphorus loss
                            <HelpTooltip tip={`The estimated phosphorus loss from the ${platform}`} />
                        </h5>
                        <div className="u-mt-sm u-pl-lg">
                            <div className="HeroValue-item-number" id="ploss-total">
                                {utils.numeric.format(platformResults.phosphorus.totalLoss.value)} <small>{platformResults.phosphorus.totalLoss.unit.notation}</small>
                            </div>
                            <div className="HeroValue-item-number" id="ploss-ha">
                                {utils.numeric.format(platformResults.phosphorus.lossPerHectare.value, 1)} <small>{platformResults.phosphorus.lossPerHectare.unit.notation}</small>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="ColourPanel ColourPanel--ghg">
                    <div className="u-pl-md">
                        <h5>
                            GHG emissions
                            <HelpTooltip tip={`The estimated GHG emissions from the ${platform}`} />
                        </h5>
                        <div className="u-mt-sm u-pl-lg">
                            <div className="HeroValue-item-number" id="ghg-total">
                                {utils.numeric.format(platformResults.ghg.emissions.totalEmissions.value, 1)} <small>{platformResults.ghg.emissions.totalEmissions.unit.notation}</small>
                            </div>
                            <div className="HeroValue-item-number" id="ghg-ha">
                                {utils.numeric.format(platformResults.ghg.emissions.emissionsPerHectare.value)} <small>{platformResults.ghg.emissions.emissionsPerHectare.unit.notation}</small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
